import { ChainId } from './constants'
import { Currency } from './Currency'
import { validateAndParseAddress } from './utils'

/**
 * Represents an ERC20 token with a unique address and some metadata.
 */
export class Token extends Currency {
  public readonly chainId: ChainId
  public address: string

  public constructor(chainId: ChainId, address: string, decimals: number, symbol?: string, name?: string) {
    super(decimals, symbol, name)
    this.chainId = chainId
    this.address = validateAndParseAddress(address)
  }

  /**
   * Returns true if the two tokens are equivalent, i.e. have the same chainId and address.
   * @param other other token to compare
   */
  public equals(other: Token): boolean {
    // short circuit on reference equality
    if (this === other) {
      return true
    }
    return this.chainId === other.chainId && this.address === other.address
  }

  /**
   * Returns true if the address of this token sorts before the address of the other token
   * @param other other token to compare
   * @throws if the tokens have the same address
   * @throws if the tokens are on different chains
   */
  public sortsBefore(other: Token): boolean {
    return this.address.toLowerCase() < other.address.toLowerCase()
  }
}

/**
 * Compares two currencies for equality
 */
export function currencyEquals(currencyA: Currency, currencyB: Currency): boolean {
  if (currencyA instanceof Token && currencyB instanceof Token) {
    return currencyA.equals(currencyB)
  } else if (currencyA instanceof Token) {
    return false
  } else if (currencyB instanceof Token) {
    return false
  } else {
    return currencyA === currencyB
  }
}

export const WHYDRA = {
  [ChainId.MAINNET]: new Token(
    ChainId.MAINNET,
    '0x6d9115a21863ce31b44cd231e4c4ccc87566222f',
    8,
    'WHYDRA',
    'Wrapped Hydra'
  ),
  [ChainId.ROPSTEN]: new Token(
    ChainId.ROPSTEN,
    '0x6d9115a21863ce31b44cd231e4c4ccc87566222f',
    8,
    'WHYDRA',
    'Wrapped Hydra'
  ),
  [ChainId.RINKEBY]: new Token(
    ChainId.RINKEBY,
    '0x6d9115a21863ce31b44cd231e4c4ccc87566222f',
    8,
    'WHYDRA',
    'Wrapped Hydra'
  ),
  [ChainId.GÖRLI]: new Token(ChainId.GÖRLI, '0x6d9115a21863ce31b44cd231e4c4ccc87566222f', 8, 'WHYDRA', 'Wrapped Hydra'),
  [ChainId.KOVAN]: new Token(ChainId.KOVAN, '0x6d9115a21863ce31b44cd231e4c4ccc87566222f', 8, 'WHYDRA', 'Wrapped Hydra')
}
